// Effets visuels déclenchés par des emojis dans les messages
let _actif = true;
let _canvas = null;
let _ctx = null;
let _particles = [];
let _rafId = null;

const TRIGGERS = {
    confetti: new Set(['🎉', '🎊', '🥳']),
    fireworks: new Set(['🎆', '🎇', '🧨']),
    hearts:    new Set(['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💖', '💗', '💓', '💕', '🥰', '😍']),
    stars:     new Set(['👏', '⭐', '🌟', '✨', '💫']),
};

const CONFETTI_COLORS = ['#ff6b6b','#ffd93d','#6bcb77','#4d96ff','#ff6bff','#ff9f43','#54a0ff','#5f27cd'];

export function setEffetsActifs(val) { _actif = !!val; }
export function getEffetsActifs() { return _actif; }

function _initCanvas() {
    if (_canvas) return;
    _canvas = document.createElement('canvas');
    _canvas.id = 'effects-canvas';
    _canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:99999;';
    document.body.appendChild(_canvas);
    _ctx = _canvas.getContext('2d');
    window.addEventListener('resize', _resizeCanvas);
    _resizeCanvas();
}

function _resizeCanvas() {
    if (!_canvas) return;
    _canvas.width  = window.innerWidth;
    _canvas.height = window.innerHeight;
}

// Renvoie la liste des types d'effets à déclencher pour un texte donné
function _detecterEffets(texte) {
    if (!texte || typeof texte !== 'string') return [];
    const types = new Set();
    // Itère sur les code points pour gérer correctement les emojis composés
    for (const ch of texte) {
        for (const [type, set] of Object.entries(TRIGGERS)) {
            if (set.has(ch)) types.add(type);
        }
    }
    return [...types];
}

// ─── Factories de particules ───────────────────────────────────────────────

function _spawnConfetti() {
    const W = _canvas.width, H = _canvas.height;
    const cx = W / 2;
    for (let i = 0; i < 90; i++) {
        const angle = (Math.random() * 160 - 80) * Math.PI / 180;
        const speed = 4 + Math.random() * 10;
        _particles.push({
            type: 'confetti',
            x: cx + (Math.random() - 0.5) * 200,
            y: -10,
            vx: Math.sin(angle) * speed,
            vy: Math.cos(angle) * speed * 0.6,
            rot: Math.random() * Math.PI * 2,
            vrot: (Math.random() - 0.5) * 0.3,
            w: 8 + Math.random() * 8,
            h: 4 + Math.random() * 4,
            color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
            life: 1,
            decay: 0.008 + Math.random() * 0.006,
        });
    }
}

function _spawnFireworks() {
    const W = _canvas.width, H = _canvas.height;
    const cx = W * (0.3 + Math.random() * 0.4);
    const cy = H * (0.2 + Math.random() * 0.3);
    const count = 70;
    for (let i = 0; i < count; i++) {
        const angle = (i / count) * Math.PI * 2 + Math.random() * 0.3;
        const speed = 3 + Math.random() * 8;
        _particles.push({
            type: 'spark',
            x: cx, y: cy,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            r: 2 + Math.random() * 3,
            color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
            life: 1,
            decay: 0.012 + Math.random() * 0.01,
            trail: [],
        });
    }
    // 2e salve décalée
    setTimeout(() => {
        if (!_canvas) return;
        const cx2 = W * (0.3 + Math.random() * 0.4);
        const cy2 = H * (0.15 + Math.random() * 0.25);
        for (let i = 0; i < 50; i++) {
            const angle = (i / 50) * Math.PI * 2 + Math.random() * 0.4;
            const speed = 2 + Math.random() * 7;
            _particles.push({
                type: 'spark',
                x: cx2, y: cy2,
                vx: Math.cos(angle) * speed,
                vy: Math.sin(angle) * speed,
                r: 1.5 + Math.random() * 2.5,
                color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
                life: 1,
                decay: 0.015 + Math.random() * 0.01,
                trail: [],
            });
        }
        _ensureLoop();
    }, 350);
}

function _spawnHearts() {
    const W = _canvas.width, H = _canvas.height;
    const EMOJIS = ['❤️','💖','💗','💕','💓','🧡','💛'];
    for (let i = 0; i < 18; i++) {
        _particles.push({
            type: 'emoji',
            emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
            x: W * (0.2 + Math.random() * 0.6),
            y: H * (0.7 + Math.random() * 0.2),
            vx: (Math.random() - 0.5) * 1.5,
            vy: -(2 + Math.random() * 3),
            size: 20 + Math.random() * 20,
            life: 1,
            decay: 0.008 + Math.random() * 0.007,
            delay: i * 60,
        });
    }
}

function _spawnStars() {
    const W = _canvas.width, H = _canvas.height;
    const cx = W / 2, cy = H / 2;
    const EMOJIS = ['✨','⭐','🌟','💫'];
    for (let i = 0; i < 30; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = 2 + Math.random() * 6;
        _particles.push({
            type: 'emoji',
            emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
            x: cx + (Math.random() - 0.5) * 100,
            y: cy + (Math.random() - 0.5) * 100,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            size: 18 + Math.random() * 16,
            life: 1,
            decay: 0.01 + Math.random() * 0.01,
            delay: i * 40,
        });
    }
}

// ─── Boucle de rendu ──────────────────────────────────────────────────────

let _frameTime = 0;
function _loop(ts) {
    if (!_particles.length) { _rafId = null; _ctx.clearRect(0, 0, _canvas.width, _canvas.height); return; }
    const dt = Math.min((ts - _frameTime) / 16.67, 3); // normalisé à 60fps
    _frameTime = ts;

    _ctx.clearRect(0, 0, _canvas.width, _canvas.height);

    const alive = [];
    for (const p of _particles) {
        if (p.delay && p.delay > 0) { p.delay -= 16; alive.push(p); continue; }

        p.life -= p.decay * dt;
        if (p.life <= 0) continue;

        p.x += p.vx * dt;
        p.y += p.vy * dt;

        if (p.type === 'confetti') {
            p.vy += 0.25 * dt; // gravité
            p.vx *= 0.99;
            p.rot += p.vrot * dt;
            _ctx.save();
            _ctx.globalAlpha = Math.min(1, p.life * 1.5);
            _ctx.translate(p.x, p.y);
            _ctx.rotate(p.rot);
            _ctx.fillStyle = p.color;
            _ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
            _ctx.restore();

        } else if (p.type === 'spark') {
            p.vy += 0.15 * dt; // légère gravité
            p.trail.push({ x: p.x, y: p.y });
            if (p.trail.length > 5) p.trail.shift();
            _ctx.save();
            _ctx.globalAlpha = p.life * 0.8;
            // traîne
            if (p.trail.length > 1) {
                _ctx.strokeStyle = p.color;
                _ctx.lineWidth = p.r * 0.6;
                _ctx.beginPath();
                _ctx.moveTo(p.trail[0].x, p.trail[0].y);
                p.trail.forEach(pt => _ctx.lineTo(pt.x, pt.y));
                _ctx.stroke();
            }
            _ctx.fillStyle = p.color;
            _ctx.beginPath();
            _ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
            _ctx.fill();
            _ctx.restore();

        } else if (p.type === 'emoji') {
            _ctx.save();
            _ctx.globalAlpha = Math.min(1, p.life * 2);
            _ctx.font = `${Math.round(p.size)}px serif`;
            _ctx.textAlign = 'center';
            _ctx.textBaseline = 'middle';
            _ctx.fillText(p.emoji, p.x, p.y);
            _ctx.restore();
        }

        alive.push(p);
    }
    _particles = alive;
    _rafId = requestAnimationFrame(_loop);
}

function _ensureLoop() {
    if (_rafId) return;
    _frameTime = performance.now();
    _rafId = requestAnimationFrame(_loop);
}

// ─── API publique ─────────────────────────────────────────────────────────

export function triggerMessageEffect(texte) {
    if (!_actif) return;
    const types = _detecterEffets(texte);
    if (!types.length) return;
    _initCanvas();
    _resizeCanvas();
    for (const type of types) {
        if (type === 'confetti')  _spawnConfetti();
        if (type === 'fireworks') _spawnFireworks();
        if (type === 'hearts')    _spawnHearts();
        if (type === 'stars')     _spawnStars();
    }
    _ensureLoop();
}
